/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9ib29raW5nLW1hbmFnZW1lbnQvcGF5cm9sbC10aW1lL3BheXJvbGwtdGltZS5jb21wb25lbnQuY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9ib29raW5nLW1hbmFnZW1lbnQvcGF5cm9sbC10aW1lL3BheXJvbGwtdGltZS5jb21wb25lbnQudHMiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/booking-management/payroll-time/payroll-time.component.css.shim.ngstyle.ts